export default __webpack_public_path__ + "static/media/ground_grass.8341d4d5.png";